import * as angular from "angular";
import {IController} from "angular";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ServicesViewsStateType} from "../../../deliveries/types/services-views-state.type";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {ViewsStateType} from "../../../commons/types/views-state.type";
import {GlobalSearchItemsType} from "../../../search/types/global-search-items.type";
import * as _ from "lodash";

export class ViewsConfigurationViewComponent implements IController {

  configurationSettings: ViewSettingsModel[];


  public views: string[];
  public viewsDefaultTableConfiguration: any;
  public viewsTableConfiguration: {} = {};
  public inEditModeView: string;
  public servicesViewsStateType: typeof ServicesViewsStateType = ServicesViewsStateType;
  public viewsStateTypes: typeof ViewsStateType = ViewsStateType;
  public globalSearchTypes: typeof GlobalSearchItemsType = GlobalSearchItemsType;
  public defaultHomePageSettings: ViewSettingsModel;
  public generalSettings: ViewSettingsModel;

  constructor(private commonsConstants, private viewSettingsService: ViewSettingsService, private IAMPermissions) {
  }

  $onInit() {
    this.views = [
      this.servicesViewsStateType.DELIVERIES_TABLE_STATE,
      this.servicesViewsStateType.DELIVERIES_MAP_STATE,
      this.servicesViewsStateType.DELIVERIES_FORM_STATE
    ];

    this.defaultHomePageSettings = this.configurationSettings?.find(c => c.settingsType === ViewSettingsType.HomePage);
    this.generalSettings = this.configurationSettings?.find(c => c.settingsType === ViewSettingsType.GeneralSettings);

    if (!this.generalSettings) {
      this.generalSettings = {
        settings: {
          globalSearch: {
            value: GlobalSearchItemsType.Services
          }
        }
      };
    }

    this._initViewTableConfiguration();
  }

  onToggleEdit(viewName: string) {
    this.inEditModeView = viewName;
  }

  onChangeValue(viewName: string, key: string, value: string) {
    this.viewsTableConfiguration[viewName][key] = value;
  }

  onCancelEdit() {
    this.inEditModeView = undefined;
    this._initViewTableConfiguration();
  }

  onEditTableSettings(viewName: string) {
    const viewTableSettings = this.configurationSettings.find(s => s.pageName === viewName);

    const settings = {};

    for (const key in this.viewsTableConfiguration[viewName]) {
      settings[key] = this.viewsTableConfiguration[viewName][key] ? 1 : 0;
    }

    if (viewTableSettings) {
      const viewTableSettingsCopy = {...viewTableSettings, settings: settings}
      this.viewSettingsService.updateByUser(viewTableSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          const viewTableSettingsIndex = this.configurationSettings.findIndex(s => s.pageName === viewName);
          this.configurationSettings[viewTableSettingsIndex] = viewSettingsTable;
          this.inEditModeView = undefined;
          this._initViewTableConfiguration();
        })
    } else {
      const viewTableSettings = {
        pageName: viewName,
        holderType: ViewSettingsHolderType.Site,
        settingsType: ViewSettingsType.ViewTable,
        settings: settings
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.configurationSettings.push(viewSettingsTable);
          this.inEditModeView = undefined;
          this._initViewTableConfiguration();
        })
    }
  }

  onEditFormSettings(viewName: string) {
    const viewTableSettings = this.configurationSettings.find(s => (s.pageName === viewName && s.settingsType === ViewSettingsType.Form));

    const settings = {};

    for (const key in this.viewsTableConfiguration[viewName]) {
      settings[key] = this.viewsTableConfiguration[viewName][key];
    }

    if (viewTableSettings) {
      const viewTableSettingsCopy = {...viewTableSettings, settings: settings}
      this.viewSettingsService.updateByUser(viewTableSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          const viewTableSettingsIndex = this.configurationSettings.findIndex(s => s.pageName === viewName);
          this.configurationSettings[viewTableSettingsIndex] = viewSettingsTable;
          this.inEditModeView = undefined;
          this._initViewTableConfiguration();
        })
    } else {
      const viewTableSettings = {
        pageName: viewName,
        holderType: ViewSettingsHolderType.Site,
        settingsType: ViewSettingsType.Form,
        settings: settings
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.configurationSettings.push(viewSettingsTable);
          this.inEditModeView = undefined;
          this._initViewTableConfiguration();
        })
    }
  }

  onResetToDefault(viewName: string) {
    const viewTableSettingsIndex = this.configurationSettings.findIndex(s => (s.pageName === viewName && s.settingsType === ViewSettingsType.Form));

    if (viewTableSettingsIndex > -1) {
      const settingsObj = this.configurationSettings[viewTableSettingsIndex].settings;
      const defaults = this.viewsDefaultTableConfiguration[viewName];

      if (defaults) {
        const keys = Object.keys(settingsObj);
        keys.forEach(key => {
          if (!_.isUndefined(defaults[key])) {
            settingsObj[key] = defaults[key];
          } else {
            _.unset(settingsObj, key);
          }
        });

        Object.keys(defaults).forEach(key => {
          if (_.isUndefined(settingsObj[key])) {
            settingsObj[key] = defaults[key];
          }
        });
      } else {
        const keys = Object.keys(settingsObj);
        keys.forEach(key => {
          _.unset(settingsObj, key);
        });
      }

      this.onEditFormSettings(viewName);
    }
  }

  onChangeDefaultHomePage(key) {
    if (this.defaultHomePageSettings) {
      const defaultHomePageSettingsCopy = {...this.defaultHomePageSettings, pageName: key}
      this.viewSettingsService.updateByUser(defaultHomePageSettingsCopy.id, defaultHomePageSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.defaultHomePageSettings = viewSettingsTable;
        })
    } else {
      const viewTableSettings = {
        pageName: key,
        holderType: ViewSettingsHolderType.Site,
        settingsType: ViewSettingsType.HomePage
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.defaultHomePageSettings = viewSettingsTable
        })
    }
  }

  onChangeDefaultGlobalSearch(globalSearchType: GlobalSearchItemsType) {
    if (this.generalSettings?.id) {
      const generalSettingsCopy = {...this.generalSettings}

      if (!generalSettingsCopy.settings.globalSearch) {
        generalSettingsCopy.settings.globalSearch = {}
      }
      generalSettingsCopy.settings.globalSearch.value = globalSearchType;

      this.viewSettingsService.updateByUser(generalSettingsCopy.id, generalSettingsCopy)
        .then((generalSettings: ViewSettingsModel) => {
          this.generalSettings = generalSettings;
        })
    } else {
      const viewTableSettings = {
        holderType: ViewSettingsHolderType.Site,
        settingsType: ViewSettingsType.GeneralSettings,
        settings: {
          globalSearch: {value: globalSearchType}
        }
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((generalSettings: ViewSettingsModel) => {
          this.generalSettings = generalSettings
        })
    }
  }

  private _initViewTableConfiguration() {
    this.viewsDefaultTableConfiguration = angular.copy(this.commonsConstants.viewsTableColumns);

    this.views.forEach((v: string) => {
      const configuration = this.configurationSettings.find((cs: ViewSettingsModel) => cs.pageName === v);
      if (configuration && this.viewsDefaultTableConfiguration[v]) {
        this.viewsTableConfiguration[v] = configuration.settings;
        
        _.forOwn(this.viewsDefaultTableConfiguration[v], (value, key) => {
          if (_.isUndefined(this.viewsTableConfiguration[v][key])) {
            this.viewsTableConfiguration[v][key] = value;
          }
        })

      } else {
        this.viewsTableConfiguration[v] = this.viewsDefaultTableConfiguration[v];
      }
    })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('viewsConfigurationView', {
    bindings: {
      configurationSettings: '<'
    },
    template: require('./views-configuration-view.html').default,
    controller: ViewsConfigurationViewComponent
  });
